import React from "react";
import { connect } from "react-redux";
import axios from "axios";
import Header from "../HeaderComponent/Header";
import history from "../../auth/history";
import './SendersList.css';
import './SenderDetails.css';

import './SenderPhotoUpload.css';
import FooterComponet from "../FooterComponent/FooterComponet";
import SenderData from './SenderData';
import Pagination from "react-js-pagination";
import { setSendersListDetails, setTotalSenders } from "../../redux/misc-data/misc-data.action";
import { store } from "../../redux/store";
import { setSendersListPageDetails } from './../../redux/misc-data/misc-data.action';
import HeaderCommon from './../HeaderComponent/HeadeCommon';
import ContentLoader from 'react-content-loader';
import Menu from "../MenuComponent/Menu";
import { Link } from "react-router-dom";
import tokenErrorHandler from "../tokenErrorHandler";

const httpClient = axios.create();
class SendersList extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			password: '',
			otpRef: '',
			message: '',
			activePage: 1,
			errorMessage: '',
			contentLoading: false
		}
	}

	handlePageChangeDefault(pageNumber) {
		console.log('showing records from ' + (pageNumber - 1) * 8 + ' to ' + pageNumber * 8 + ' of ' + this.props.totalSenders + ' no of records');
		this.setState({
			activePage: pageNumber
		})
		var senderList = this.props.senderListDetails.slice((pageNumber - 1) * 8, pageNumber * 8)
		store.dispatch(setSendersListPageDetails(senderList));
	}



	componentDidMount() {

		this.setState({
			contentLoading: true
		})

		store.dispatch(setSendersListDetails(''));
		store.dispatch(setSendersListPageDetails(''));
		store.dispatch(setTotalSenders(0));

		var allsenderuRL = '/api/v1/dmt/customer/list/' + this.props.agentInfo.id + '/0';
		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo.id,
			'role': this.props.clientRole
		}

		httpClient.get(allsenderuRL, { headers }
		).then((response) => {

			this.setState({
				contentLoading: false
			})
			console.log('all senders response' + JSON.stringify(response.data));
			if (response.data.response.msg == 'SUCCESS') {
				store.dispatch(setSendersListDetails(response.data.list));
				store.dispatch(setSendersListPageDetails(response.data.list));
				store.dispatch(setTotalSenders(response.data.totalElements));

			} else {

				this.setState({
					errorMessage:response.displayMsg
				})
				
			}
		}).catch(error => {
			this.setState({
				contentLoading: false,
				errorMessage:error.message
			})

			
			if(error.message.includes("401")){
				tokenErrorHandler.tokenErrorHandle(error.message,this.props.callBackUrl)
			}else{
				
			}
		});

	}
	componentWillUnmount() {
	}






	render() {

		return (

			<div>
				<HeaderCommon />
				<Menu />
				<div class="main">


					<div class="right-side">
						<div class="container-fluid">



							<div class="row">
								<div class="col-12">
									<div class="card-b">

										<div class="head">
											<h3>Sender List</h3>

											<div class="headbtn">
												<Link to='/dmt'>
													<button class="dbbtn" type="button">Back</button>
												</Link>

											</div>
										</div>

										<div class="senderrow">
											<div class="row">


												{this.state.errorMessage == '' &&
													this.props.senderListPageDetails.length > 0 &&
													this.props.senderListPageDetails.slice(0, 8).map(customerSummary => (


														<SenderData name={customerSummary.name} mobile={customerSummary.mobile} />

													))}
												{
													this.state.errorMessage == '' &&
													this.props.senderListPageDetails.length == 0 &&
													this.state.contentLoading == false &&
													<div class="col-12 col-sm-6 col-lg-4 col-xl-3">
														No records found
													</div>
												}
												{
													this.state.errorMessage == '' &&
													this.state.contentLoading == true &&
													<ContentLoader
														width={350}

														height={50}
														speed={1}
														backgroundColor="#f3f3f3"
														foregroundColor="#ecebeb"
														viewBox="0 0 350 50"
													><rect x="48" y="8" rx="3" ry="3" width="100" height="6" />
														<rect x="48" y="26" rx="3" ry="3" width="40" height="6" />
														<circle cx="20" cy="20" r="20" />
													</ContentLoader>

												}
												{
													this.state.errorMessage != '' &&
													<div class='valid-error'>
														{this.state.errorMessage}
													</div>
												}

											</div>
										</div>
										{
											this.state.contentLoading == false &&
												this.props.totalSenders > 0 ?
												<div class="pager">
													<p>
														Showing {"Showing " + this.props.totalSenders != '' &&
															this.props.totalSenders}  entries</p>
													<Pagination
														activePage={this.state.activePage}
														itemsCountPerPage={8}
														totalItemsCount={
															this.props.totalSenders != '' &&
															this.props.totalSenders}
														pageRangeDisplayed={5}
														onChange={this.handlePageChangeDefault.bind(this)}
														className="pagination"
														linkClass="page-link"
														itemClass="page-item"
													/>
												</div>
												:
												this.state.contentLoading == false &&
												this.props.totalSenders == 0 &&
												<div>
													
												</div>

										}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<FooterComponet />
			</div>
		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, loginErrorMessage },
		miscReduce: { phone, senderListDetails, senderListPageDetails, totalSenders,
			agentInfo, token ,clientRole,callBackUrl} }
) => ({
	errorMessage, loginErrorMessage, phone, senderListDetails, senderListPageDetails, totalSenders,
	agentInfo, token,clientRole,callBackUrl
});

export default connect(mapStateToProps, null)(SendersList);
